export const MAX_DATE = new Date(253402280999000);
export const MIN_DATE = new Date(-62135618008000);
//# sourceMappingURL=constants.js.map